import camelCase from 'camelcase';
import _ from 'lodash';
import lodashFPSet from 'lodash/fp/set';

export const keysToCamelCase = (obj) => {
  const result = {};

  for (const key in obj) {
    result[camelCase(key)] = obj[key];
  }

  return result;
};

export const isEmpty = (x) => {
  if (typeof x === 'string' || Array.isArray(x)) {
    return x.length === 0;
  }

  if (_.isPlainObject(x)) {
    return Object.keys(x).length === 0;
  }

  return false;
};

export const isNilOrEmpty = (x) => {
  return isEmpty(x) || _.isNil(x);
};

export const project = (keys, arr) => arr.map((obj) => _.pick(obj, keys));

export const insert = (index, value, arr) => [...arr.slice(0, index), value, ...arr.slice(index)];

export const insertAll = (index, subArr, arr) => [
  ...arr.slice(0, index),
  ...subArr,
  ...arr.slice(index),
];

// immutable
export const set = (object, path, value) => lodashFPSet(path)(value)(object);
